import { Component, Input, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ChangeDetectorRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError, Observable, Subscription } from 'rxjs'; // Import throwError and Observable
import { TranscriptJson } from '../../../../features/intakes/src/lib/intakes/model/transcription';
import { environment } from '@portals/environments';
import { Collectible } from '@portals/api';
import { CollectiblesState } from '@portals/store';
@Component({
	selector: 'portals-intakes-transcription-row',
	templateUrl: './transcription-row.component.html',
	styleUrls: ['./transcription-row.component.scss'],
})
export class TranscriptionRowComponent implements OnInit {
	@Input() data?: Collectible;
	private transcriptionSubscription: Subscription | undefined;
	transcriptionData: TranscriptJson = {
		jobName: '',
		accountId: '',
		results: {
			transcripts: [
				{
					transcript: '',
				},
			],
			items: [],
		},
		status: '',
	};
	tooltipString?: string;
	isLoading: boolean = false;
	gistTranscript: string = '';
	transcriptSet: boolean = false;
	constructor(private http: HttpClient, private _collectibleSt: CollectiblesState, private cdRef: ChangeDetectorRef) {
		// this.row = data;
	}
	fetchTooltipData(): void {
		// console.log('fetchTooltipData');
		if (this.data?.uuid === undefined) {
			// Avoid multiple requests for the same content
			return;
		}
		if (this.data?.transcript_gist_set && this.data?.transcription_text !== '') {
			this._collectibleSt.getTranscriptionText(this.data.uuid).subscribe(
				(data: any) => {
					this.tooltipString = data.results.transcripts[0].transcript;
					this.cdRef.detectChanges();
					this.transcriptSet = true;
				},
				(error) => {
					console.error('Failed to fetch tooltip content', error);
					// 		// Handle error accordingly
				}
			);
			// this._collectibleSt.getTranscriptionText(this.data?.uuid).subscribe(
			// 	(content) => {
			// 		// console.log(content);
			// 		this.tooltipString =
			// 			content.results.transcripts[0].transcript;
			// 		this.cdRef.detectChanges();
			// 		this.transcriptSet = true;
			// 	},
			// 	(error) => {
			// 		console.error('Failed to fetch tooltip content', error);
			// 		// Handle error accordingly
			// 	}
			// );
		}
	}

	ngOnInit(): void {
		if (this.data && this.data.uuid) {
			const coll_uuid = this.data.uuid;
			if (this.data.transcript_gist_set !== true) {
				// console.log(`Trascript gist ${this.data.transcript_gist_set}`);
				this.transcriptionSubscription = this._collectibleSt.getTranscriptionText(this.data.uuid).subscribe((data) => {
					// console.log(data);
					this.transcriptionData = data;
					this.gistTranscript = this.transcriptionData.results?.transcripts[0].transcript.slice(0, 150);

					this._collectibleSt
						.putTranscriptionText(coll_uuid, {
							transcription_text: this.transcriptionData.results.transcripts[0].transcript.slice(0, 150),
						})
						.subscribe((data) => {
							// console.log(data);
						});
				});
			} else {
				this.gistTranscript = this.data?.transcription_text || 'No transcript available even though transcript were enabled.';
			}
		}
	}

	ngOnDestroy(): void {
		if (this.transcriptionSubscription) {
			this.transcriptionSubscription.unsubscribe();
		}
	}
}
